import {Send} from 'lucide-react'

export default function Community() {
  return (
    <section className="relative py-20 px-4 z-10 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 pt-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-white">
            Join Our Community
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/60 max-w-3xl">
            Connect with thousands of $MANDOX holders and enthusiasts worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <a href="https://x.com/officialmandox" target="_blank" rel="noopener noreferrer" className="p-8 bg-white/5 rounded transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] text-center">
            <svg className="w-10 h-10 text-white mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
            <h3 className="text-lg font-semibold text-white mb-1">Mandox Token</h3>
            <p className="text-white/50 text-sm">Follow for updates</p>
          </a>

          <a href="https://x.com/mandoxcreate" target="_blank" rel="noopener noreferrer" className="p-8 bg-white/5 rounded transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] text-center">
            <svg className="w-10 h-10 text-white mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
            <h3 className="text-lg font-semibold text-white mb-1">Create NFT Marketplace</h3>
            <p className="text-white/50 text-sm">Marketplace updates</p>
          </a>

          <a href="https://t.me/officialmandoX" target="_blank" rel="noopener noreferrer" className="p-8 bg-white/5 rounded transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] text-center">
            <Send className="w-10 h-10 text-white mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-white mb-1">Telegram</h3>
            <p className="text-white/50 text-sm">Join the chat</p>
          </a>
        </div>
      </div>
    </section>
  )
}
